






















































import Vue from 'vue';
import axios from 'axios';
import { ErrorResponse } from '@/api/dto/Error';
import VariableInput from '@/components/util/VariableInput.vue';
import {
  CorporateIdRegExp,
  CorporateIdConstraintMessage,
  mailAddressLengthLimit,
  mailAddressConstraintErrorMessage, 
  mailAddressRegExp,
  passwordConstraintMessage,
  passwordConstraintErrorMessage, 
  passwordRegExp, 
} from './constraint';
import FooterSimple from '@/parts/common/FooterSimple.vue';
import { updateAuthCodeFlag } from '@/jwt';
import { Dictionary } from 'vue-router/types/router';

export default Vue.extend({
  name: 'CorporateLogin',
  components: {
    VariableInput,
    FooterSimple,
  },
  props: {
    mq: String,
  },
  watch: {
    'accountData.corporateId'(corporateId: string){
      this.inputs['corporateId'].error = (CorporateIdRegExp.test(corporateId)) ? '' : CorporateIdConstraintMessage;
    },
    'accountData.mail'(mailAddress: string) {
      this.inputs['mail'].error = (mailAddress.length <= mailAddressLengthLimit && mailAddressRegExp.test(mailAddress)) ? '' : mailAddressConstraintErrorMessage;
    },
    'accountData.password'(password: string) {
      this.inputs['password'].error = passwordRegExp.test(password) ? '' : passwordConstraintErrorMessage;
    },
  },
  created (){
      this.accountData.mail = this.$route.params.mail ? this.$route.params.mail : "";
      this.accountData.password =  this.$route.params.password ? this.$route.params.password : "";
    },
  data() {
    return {
      accountData: {
        corporateId: '' ,
        mail: '',
        password: '',
      },
      inputs: {
        'corporateId' :{name: '法人ID',type:'text', placeholder:'法人ID', error:''},
        'mail': {name: 'メールアドレス', type: 'text', placeholder: 'メールアドレス', error: '' },
        'password': { name: 'パスワード', type: 'password', constraint: passwordConstraintMessage, placeholder: 'パスワード', error: '' },
      },
      generalError: '',
    }
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(
        (CorporateIdRegExp.test(this.accountData.corporateId))
        && this.accountData.mail.length <= mailAddressLengthLimit && mailAddressRegExp.test(this.accountData.mail) 
        && passwordRegExp.test(this.accountData.password));
    },
  },
  methods: {
    async onClickSubmit() {
      if (this.mq != 'pc') {
        this.$emit("errorToast", "レビュマビジネスはこの端末では利用できません。PCからログインしてください。");
        return
      }
      try {
        await this.$store.dispatch('login', { 
          corporateId: this.accountData.corporateId,
          mailAddress: this.accountData.mail,
          password: this.accountData.password,
        });
        this.$router.push({ name: "MailAuthentication", params: { mailAddress: this.accountData.mail as string } });
      } catch (e) {
        if(axios.isAxiosError(e) && e.response){
          var resError = e.response.data as ErrorResponse;
          this.generalError = resError.message;
        }
      }
    },
    onPushPath(path: string) {
    this.$router.push(path, () => {}); // eslint-disable-line
    this.$emit('pushPath', path);
    },
    onPushName(routeName: string,params: Dictionary<string> | undefined) {
      this.$router.push({
        name: routeName,
        params: params,
      });

    },
  }
})
